import { EnumTypeViewModel } from "../custom/enum";

export const getEnumValue = <T extends number | string>(
    viewModel: EnumTypeViewModel<T>
): T => viewModel.value;

export const enumValueEquals = <T extends number | string>(
    valueA: T | null | undefined,
    valueB: T
): boolean => valueA === valueB;

export const viewModelEnumValueEquals = <T extends number | string>(
    viewModel: EnumTypeViewModel<T>,
    value: T
): boolean => getEnumValue(viewModel) === value;
